import React from 'react';

interface ErrorPageProps {
  title?: React.ReactNode;
  message?: React.ReactNode;
  error?: Error;
  correlationId?: string;
}

const ErrorPage = ({ title, message, error, correlationId }: ErrorPageProps) => (
  <div style={{ textAlign: 'center', marginTop: '100px' }}>
    <h3>{title || 'Ojdå, någonting gick fel. Var god försök igen'}</h3>
    {message}
    {process.env.NODE_ENV === 'development' && error && <p>Error message: {error.message}</p>}
    {correlationId && <em>Referens: {correlationId}</em>}
  </div>
);

export default ErrorPage;
